import { useEffect, useState } from 'react'

import type { GetProfileResponse } from '@/api/user/get-profile'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { env } from '@/env'
import { api } from '@/services/axios'

import { GetCampaigns } from '../types'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  campaign: GetCampaigns | null
}

export function AwardedCampaignModal({ open, onOpenChange, campaign }: Props) {
  const [nomesGanhadores, setNomesGanhadores] = useState<
    Record<number, string>
  >({})

  useEffect(() => {
    const fetchNomes = async () => {
      if (!campaign) return

      const usuariosIds = new Set<number>()

      campaign.premios.forEach((p) => {
        const id = Number(p.usuario_Ganhador_Id)
        if (id > 0) {
          usuariosIds.add(id)
        }
      })

      console.log(usuariosIds)

      // campaign.titulosPremiados.forEach((t) => {
      //   const id = Number(t.usuario_Ganhador_Id)
      //   if (id > 0) {
      //     usuariosIds.add(id)
      //   }
      // })

      await Promise.all(
        Array.from(usuariosIds).map(async (userId) => {
          if (!userId || nomesGanhadores[userId]) return
          try {
            const { data } = await api.get<GetProfileResponse>(
              `Usuario/GetById/${userId}`,
            )
            const primeiroNome = data.nome.split(' ')[0]
            setNomesGanhadores((prev) => ({ ...prev, [userId]: primeiroNome }))
          } catch {
            setNomesGanhadores((prev) => ({
              ...prev,
              [userId]: 'Desconhecido',
            }))
          }
        }),
      )
    }

    fetchNomes()
  }, [campaign])

  if (!campaign) return null

  const formatDate = (date: Date) => {
    return new Date(date).toLocaleDateString('pt-BR')
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{campaign.campanha.titulo}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="flex items-center gap-4">
            <img
              src={`${env.VITE_API_URL}${campaign.campanha.imagem}`}
              alt="img"
              className="h-20 w-20 rounded-lg object-cover"
            />
            <div>
              <p className="text-muted-foreground text-sm">
                {campaign.campanha.descricao}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {/* PRÊMIOS  */}
            <div className="col-span-2 space-y-2">
              <p className="text-muted-foreground text-sm">Prêmios</p>
              <ul className="list-inside list-disc space-y-1">
                {campaign.premios.map((premio, index) => (
                  <li key={index} className="font-medium">
                    {`${premio.posicao}º Posição - ${premio.descricao} | Vencedor: ${
                      premio.usuario_Ganhador_Id !== undefined
                        ? nomesGanhadores[premio.usuario_Ganhador_Id] ||
                          'Carregando...'
                        : 'Não definido'
                    }`}
                  </li>
                ))}
              </ul>
            </div>

            {/* TÍTULO PREMIADO */}
            {campaign.titulosPremiados.length > 0 &&
              campaign.titulosPremiados.every(
                (t) => t.Status === 'Pendente',
              ) && (
                <div className="col-span-2 space-y-2">
                  <p className="text-muted-foreground text-sm">
                    Títulos Premiados
                  </p>
                  <ul className="list-inside list-disc space-y-1">
                    {campaign.titulosPremiados.map((titulo, index) => (
                      <li key={index} className="font-medium">
                        {`${titulo.premio} | Vencedor: ${
                          titulo.usuario_Ganhador_Id !== undefined
                            ? nomesGanhadores[titulo.usuario_Ganhador_Id] ||
                              'Carregando...'
                            : 'Não definido'
                        }`}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

            {/* DATA DO SORTEIO */}
            <div className="col-span-2 space-y-2">
              <p className="text-muted-foreground text-sm">Data do sorteio</p>
              <p className="font-medium">
                {campaign.campanha.dt_Sorteio
                  ? formatDate(campaign.campanha.dt_Sorteio)
                  : 'Após venda de todos títulos!!'}
              </p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
